import React from "react"

import {Link} from "actb"

import { Card, Icon } from 'antd'


export default function SideNote(props){
    const {title, style, children, more, ...other} = props
    return (
        <Card 
        className="side-note" 
        title={<Icon type="bulb"/>} 
        extra={<Link href={more}>More</Link>} 
        style={{ width: 300, float:"right", ...(style || {}) }}
        {...other}
        >
            {children}
        </Card>
    )
}